/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import UsuarioDocas from 'Models/docas/Usuario'
import ApiService from 'Services/ApiService'
import { ServiceListResponse } from 'Types/ServiceResponse'

const usuario = {
  getList: async (idComponente: number) => {
    const result: AxiosResponse<ServiceListResponse<UsuarioDocas>> =
      await ApiService({ idComponente }).get<ServiceListResponse<UsuarioDocas>>(
        QueryStringFilter(`${hosts.WS_DOCAS}/usuario`),
      )

    return result
  },
}

export default usuario
